import cx from 'classnames'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import MenuButton, { MenuItem } from 'common/components/menuButton'
import Base from 'common/components/table/cells/Base'
import {
  Bin,
  Clipboard,
  MoreLikeThis,
  MoreOptions,
  Refresh,
  Spinner,
} from 'common/icons'
type Props = {
  onCopy: () => void
  onRefresh: () => void
  onDelete: () => void
  onMoreLikeThis: () => void
  isRefreshing: boolean
  isMoreLikeThisEnabled?: boolean
  isLoadingMoreLikeThis?: boolean
}

export const ActionCells = ({
  onCopy,
  onRefresh,
  onDelete,
  onMoreLikeThis,
  isRefreshing,
  isMoreLikeThisEnabled,
  isLoadingMoreLikeThis,
}: Props) => (
  <Base className="group invisible text-coolGray-400 group-hover:visible">
    {isMoreLikeThisEnabled && (
      <ButtonWithTooltip
        className={cx({ 'group visible': isLoadingMoreLikeThis })}
        tooltip={true}
        tooltipText="More like this"
        aria-label="More like this"
        size="small"
        prefixIcon={
          isLoadingMoreLikeThis ? (
            <Spinner className="animate-spin text-orange-400" />
          ) : (
            <MoreLikeThis
              isDefaultColor={false}
              className=" hover:text-orange-400"
            />
          )
        }
        onClick={onMoreLikeThis}
      />
    )}
    <ButtonWithTooltip
      className={cx({ 'group visible': isRefreshing })}
      tooltip={true}
      tooltipText={isRefreshing ? 'Refreshing...' : 'Refresh'}
      aria-label="Refresh"
      size="small"
      prefixIcon={
        isRefreshing ? (
          <Spinner className="animate-spin text-orange-400" />
        ) : (
          <Refresh isDefaultColor={false} className=" hover:text-orange-400" />
        )
      }
      onClick={!isRefreshing ? onRefresh : () => {}}
    ></ButtonWithTooltip>
    <MenuButton
      portal
      buttonProps={{
        'aria-label': 'More options',
        children: (
          <MoreOptions
            isDefaultColor={false}
            className="hover:text-orange-400"
          />
        ),
      }}
      options={
        <>
          <MenuItem key="1" onClick={onCopy} aria-label="Copy">
            <Clipboard
              isDefaultColor={false}
              className="mr-4 text-coolGray-400"
            />
            Copy to clipboard
          </MenuItem>
          <MenuItem key="2" onClick={() => onDelete()} aria-label="Delete">
            <Bin isDefaultColor={false} className="mr-4 text-coolGray-400" />
            Delete
          </MenuItem>
        </>
      }
    />
  </Base>
)
